import {
  LOGIN_BEGIN,
  LOGIN_ERROR,
  LOGOUT_BEGIN,
  PROFILE_UPDATE,
  SET_MOBILE_FAVORITES,
  SET_CURRENT_USER_WAREHOUSE,
  USER_DATA,
} from '../actions/actionType'
import { DEFAULT_MOBILE_FAVORITES, MAX_MOBILE_FAVORITES } from '../constants/Constants'

const normalizeMobileFavorites = (favorites, fallback = DEFAULT_MOBILE_FAVORITES) => {
  let parsedFavorites = favorites

  if (typeof favorites === 'string') {
    try {
      parsedFavorites = JSON.parse(favorites)
    } catch (error) {
      parsedFavorites = fallback
    }
  }

  if (!Array.isArray(parsedFavorites)) return fallback

  return [...new Set(parsedFavorites.filter((favorite) => typeof favorite === 'string'))].slice(
    0,
    MAX_MOBILE_FAVORITES,
  )
}

const initialState = {
  isLoggedIn: null,
  salutation_id: null,
  id: 0,
  name: '',
  first_name: '',
  last_name: '',
  email: '',
  home_phone: '',
  cell_phone: '',
  office_phone: '',
  office_extension: '',
  job_title: null,
  address1: null,
  address2: null,
  city: null,
  postal_code: null,
  province_id: null,
  country_id: null,
  language_id: 1,
  warehouse_id: null,
  status: 0,
  department_id: null,
  employee: null,
  role: [],
  permissions: [],
  clients: [],
  errorMsg: '',
  email_verified_at: null,
  mobile_favorites: DEFAULT_MOBILE_FAVORITES,
}
export default function currentUserReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_BEGIN:
      return { ...initialState, isLoggedIn: false }
    case LOGOUT_BEGIN:
      return { ...initialState, isLoggedIn: false }
    case LOGIN_ERROR:
      return { ...action.payload, isLoggedIn: false }
    case USER_DATA:
      return {
        ...initialState,
        ...action.payload,
        mobile_favorites: normalizeMobileFavorites(action.payload?.mobile_favorites),
        isLoggedIn: true,
      }
    case PROFILE_UPDATE:
      return {
        ...initialState,
        ...action.payload,
        mobile_favorites: normalizeMobileFavorites(
          action.payload?.mobile_favorites,
          state.mobile_favorites,
        ),
        isLoggedIn: true,
      }
    case SET_MOBILE_FAVORITES:
      return {
        ...state,
        mobile_favorites: normalizeMobileFavorites(action.payload, []),
      }
    case SET_CURRENT_USER_WAREHOUSE:
      return { ...state, warehouse_id: action.payload }
    default:
      return state
  }
}
